<template>
  <div>
    <nav-breadcrumb :menu="[{label: '提前还款'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
        :row-class-name="rowClassName"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";
  import moment from 'moment'
    export default {
        name: "ApplyingRepaymentInAdvanceList",
      data(){
        return{
          columns:[
            {
              type: 'index'
            },
            {
              label: '申请编号',
              field: 't__applicationNo'
            },
              {
                  label: '贷款编号',
                  field: 'fi__contractNo'
              },
            {
              label: '客户姓名',
              field: 'fi__customerName'
            },

            {
              name: '申请时间',
              field: 't__applicationDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              name: '提前还款日期',
              field: 't__repayDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '状态',
              field: 't__applicationStatus',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '审核',
                  class: 'el-icon-success',
                  clickHandler: (index, row)=> {
                    this.$router.push(
                      {
                        path: 'approve',
                        query: {
                          applicationId: row.t__applicationId
                        }
                      }
                    )
                  },
                  conditions: row=> {
                    return row.t__hasRole == 'true'&&row.t__roleId==this.tableData.variables.r0&&row.t__applicationStatus=='Pending Approval'

                  }
                },
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row)=>{
                    this.$router.push(
                      {
                        path: 'view',
                        query: {
                          applicationId: row.t__applicationId
                        }
                      }
                    )
                  }
                }
              ]
            }
          ],
          tableData: {
            count: 0,
            data: [],
            variables:{}
          },
          page: 1,
          pageSize: 20,
          actions: [
              {
                  label: '导出',
                  class: 'el-button--primary',
                  clickHandler: ()=>{
                      let routeData = this.$router.resolve({
                          path: '/ix/fang/repayment/reporting/RepaymentInAdvance.List?format=xls',
                          query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
                      });
                      window.open(routeData.href.replace('#/', '/'), '_blank');
                  },
              },
            {
              label: '提前还款试算',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'Edit'
                })
              },
            }
          ],
          filters: {
            labelWidth: '150px',
            form: {
              fi__customerName:'',
              fi__contractNo:'',
              t__applicationStatus:'',
              t__applicationDate:[],
              t__repayDate:[],
            },
            columns: [
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'fi__customerName'
              },
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__contractNo'
              },
              {
                label: '申请日期',
                component: 'date-range-picker',
                field: 't__applicationDate',
                op: ['gteq', 'lteq'],
                dateFormat: ['yyyy-MM-dd 00:00:00','yyyy-MM-dd 23:59:59'],
                span: 14
              },
              {
                label: '状态',
                component: 'el-select',
                field: 't__applicationStatus',
                options: [
                  {
                    label:'待审核',
                    value:'Pending Approval'
                  },
                  {
                    label:'审核通过',
                    value:'Approved'
                  },
                  {
                    label:'审核不通过',
                    value:'Rejected'
                  },
                ],
                span:10,
              },
              {
                label: '提前还款日期',
                component: 'date-range-picker',
                field: 't__repayDate',
                op: ['gteq', 'lteq'],
                dateFormat: ['yyyy-MM-dd 00:00:00','yyyy-MM-dd 23:59:59'],
                span: 14
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },
          rowClassName: function ({row, idx}) {
            return row.t__applicationStatus||''
          }
        }
      },
      mounted() {
        this.getData()
      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 't.applicationDate',
            'xlist.sort.order': 'desc'
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getApplyingRepaymentInAdvanceList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApplyingRepaymentInAdvanceList.vue